<template>
  <div>
    <div v-if="lat && lng">

<!--
      <center><a :href="'https://maps.googleapis.com/maps/api/directions/json?origin=null&destination=' + lat + ',' + lng + '&key=' + key"  target="_blank">Directions</a></center>
-->

      <!-- XOL-67 (v2.2, decision 172; UX spec C6): the place search, ABOVE the map and never a map control (an Element popper is appended to the body and would be
           hidden in fullscreen). A pick pans and zooms the map only: it places no pin (`place-found` tells the parent). The label is plain Element markup, not an
           el-form-item: the atom may sit inside a form (RtaRequestFields) or outside one. The input is a remote, filterable el-select as the library's
           XOL-653 picker, without `multiple`; Element's own 300 ms remote debounce is the only debounce. -->
      <div :class="{ 'atom-map__above': searchBeside }">

      <!-- Decision 176: with `search-beside` the slot comes FIRST and the search after it, on one row (the tab order follows). -->
      <slot v-if="searchBeside" name="above-map"></slot>

      <div v-if="searchable" class="atom-map__search el-form-item">
        <label class="el-form-item__label" :for="searchId">{{ searchLabel }}</label>
        <div class="el-form-item__content">
          <el-select
            ref="search"
            v-model="picked"
            class="atom-map__search-select"
            :id="searchId"
            filterable
            remote
            clearable
            reserve-keyword
            :remote-method="onQuery"
            :loading="searching"
            :loading-text="searchLoadingText"
            :no-data-text="searchNoData"
            :disabled="placesOff"
            :placeholder="searchPlaceholder"
            popper-class="atom-map__search-popper"
            @change="onPick"
            @clear="onSearchClear">
            <el-option v-for="item in searchItems" :key="item.value" :label="item.label" :value="item.value">
              <span class="atom-map__opt-main">{{ item.main }}</span>
              <span v-if="item.secondary" class="atom-map__opt-sec">{{ item.secondary }}</span>
            </el-option>
          </el-select>
        </div>
        <small class="text-muted atom-map__search-note" aria-live="polite">{{ searchNote }}</small>
      </div>

      <!-- Content for the space between the search row and the map (RtaRequestFields puts Lat / Lng there: search, Lat / Lng, map). -->
      <slot v-if="!searchBeside" name="above-map"></slot>

      </div>

      <gmap-map
        :ref="mapRef"
        :class="{ 'atom-map--aspect': aspect === '16:10' }"
        :center="mapCenter"
        :options="mapOptions"
        :zoom="zoom" :map-type-id="mapType"
        :style="mapBox"
        @click="onMapClick"
        @mouseover="statusText = 'Hello There!'"
        @mouseout="statusText = null">

      <!-- XOL-67 (v2.2; UX spec C4): the floating pin button, a custom Google control (BOTTOM_CENTER) so it stays on the map in fullscreen and is in the tab
           order. ALWAYS rendered and shown with v-show, never v-if: Google re-parents this node into its own control container, and Vue must keep the one it
           made. mounted() pushes it into map.controls, beforeDestroy removes it. The atom only says "press" (`pin-to-centre`); the parent moves the pin. -->
      <!-- XOL-67 (V8 fixes, decision 179): the SAME control can also hold the caller's own buttons, in the `map-controls` slot, beside the pin button: one
           grouped panel (white, rounded, shadowed, like Google's own controls). With the slot, the wrapper is a `role="group"` named by `control-label`; with
           neither the pin button nor any slot content it stays hidden. No slot: exactly the v2.2 control. -->
      <div
        ref="centreControl"
        v-show="controlShown()"
        class="atom-map__control"
        :class="{ 'atom-map__control--group': hasControlSlot() }"
        :role="hasControlSlot() ? 'group' : undefined"
        :aria-label="hasControlSlot() && controlLabel ? controlLabel : undefined">
        <el-button
          v-if="!!centreButton"
          type="primary"
          size="small"
          :icon="centreIcon"
          :title="centreTitle || undefined"
          :aria-describedby="centreDescribedBy || undefined"
          @click="onCentreClick">{{ centreButton }}</el-button>
        <span v-if="!!centreButton && controlSlotHasContent()" class="atom-map__control-divider" aria-hidden="true"></span>
        <div v-if="hasControlSlot()" class="atom-map__control-slot"><slot name="map-controls"></slot></div>
      </div>

      <gmap-marker
        v-if="mapPosition"
        :position="mapPosition"
        :clickable="clickable"
        :draggable="!hasMarkers ? draggable : false"
        @dragend="updatePos"
        :icon="showNominal ? nominalMapPin() : defaultMapPin()"
        :title="pinTitle || undefined"
        @click="center=mapPosition" />

      <!-- XOL-67 (V3, decisions 144, 147, 156; UX spec 2.2.7, 2.4 "Pin images"): the RTA's pins, drawn from the model of lib/rtaOption.markersFor*Map
           ({ key, kind, position, icon, label, draggable, opensOption, optionNo }). The label is the hover text; an option's pin carries its number as a
           dark badge; a pin that opens an option is clickable; a draggable one reports where it was dropped (the request's crosshairs report `update`,
           as the centre pin does, so the request form reads both the same way). Independent of `markers` (the legacy marker table). -->
      <gmap-marker
        v-for="m in pins"
        :key="m.key"
        :position="m.position"
        :icon="pinIcon(m)"
        :label="pinLabel(m)"
        :title="m.label || undefined"
        :draggable="m.draggable === true"
        :clickable="m.draggable === true || !!m.opensOption"
        :z-index="m.key === highlight ? 1000 : undefined"
        :animation="pinAnimation(m)"
        @click="onPinClick(m)"
        @mouseover="onPinHover(m)"
        @mouseout="onPinHover(null)"
        @dragend="onPinDrag(m, $event)" />

      <template v-if="hasMarkers">

        <gmap-marker v-for="(m, i) in mrk" :key="i"
          :position="position(m.position)"
          :clickable="dragMarkers"
          :draggable="dragMarkers"
          @dragend="updateMarkerPos"
          :icon="m.icon ? m.icon : defaultMapPin()"
          @click="markerDrag(i)" />
      </template>

    </gmap-map>

<!--
<el-popover
  placement="top"
  width="160"
  v-model="visible">
  <p>Are you sure to delete this?</p>
  <div style="text-align: right; margin: 0">
    <el-button size="mini" type="text" @click="visible = false">cancel</el-button>
    <el-button type="primary" size="mini" @click="visible = false">confirm</el-button>
  </div>
  <template #reference><el-button>Delete</el-button></template>
</el-popover>
-->
    <el-row v-if="hasMarkers">

      <el-col v-if="canAdd" :span="24" align="center" style="padding-top: 0.528em; padding-bottom: 0.528em;">

        <el-button
          :type="adding ? 'success' : 'primary'"
          size="mini"
          icon="fa fa-map-marker"
          @click="toggleAdd">

          {{adding ? ' Add to Map' : ' Add Marker'}}

        </el-button>

      </el-col>

      <el-col :span="24" align="left">
        <el-collapse accordion v-model="item">

          <el-collapse-item v-if="adding" name="addMarker" :disabled="!adding">
            <template #title><i class="fa fa-map-marker-alt">&nbsp;</i>Add Marker</template>

            <el-form inline>
              <select-input v-if="optionMapPins" label="Pin" v-model="marker.icon" :list="optionMapPins" is-image-list />
              <select-input v-if="options" label="Type" v-model="marker.type" :list="options" :icon-list="optionIcons" />
              <text-input label="Title" v-model="marker.infoText" />
              <float-input label="Lat." v-model="marker.position.lat" :decimals="15" />
              <float-input label="Lng." v-model="marker.position.lng" :decimals="15" />
            </el-form>

          </el-collapse-item>



          <!-- Marker Table -->
          <el-collapse-item name="table" :disabled="!adding">
            <template #title><i class="fa fa-map-marked">&nbsp;</i>Markers</template>

            <el-table stripe :data="mrk">

              <el-table-column label="Name" width="396">
                <template #default="scope">
                  <img v-if="scope.row.icon" :src="scope.row.icon" style="height: 17.4px; width: auto;" />&nbsp;<span v-safe-html="scope.row.infoText" />
                </template>
              </el-table-column>

              <el-table-column prop="position.lat" label="Lat." class-name="hidden-md-and-down" />

              <el-table-column prop="position.lng" label="Lng." class-name="hidden-md-and-down" />

              <el-table-column label="Distance" width="174">
                <template #default="scope">
                  <b>
                    {{rowDistance(scope.row)}}
                    &nbsp;<i :class="typeIcon(scope.row.type)" />
                  </b>
                </template>
              </el-table-column>

              <el-table-column
                  v-if="deleteMarkers"
                  align="right">
                  <template #default="scope">
<!--
                    <el-button
                      size="mini"
                      type="primary"
                      icon="fa fa-edit"
                      circle
                      @click="handleEdit(scope.$index, scope.row)" />
-->
                    <el-button
                      size="mini"
                      type="danger"
                      icon="fa fa-trash"
                      circle
                      @click="handleDelete(scope.$index, scope.row)"
                      :disabled="scope.$index === 0" />

                  </template>
                </el-table-column>
            </el-table>

          </el-collapse-item>

        </el-collapse>
      </el-col>

<!--      <center>Distance between point 1 &amp; 2 = </center> -->
    </el-row>

    </div>
    <div v-else>
      <center><h4>No mapping data found</h4></center>
    </div>

  </div>
</template>

<script>

import Vue from 'vue'

import * as GMap from 'gmap-vue'

import {GOOGLE_API_KEY} from '@/components/Data'

import NumberMixins from '@/mixins/NumberMixins'

import { requestMarkerLook } from '@/lib/rtaOption'
import { GOOGLE_WAIT_MS } from '@/lib/rtaNameLookup'
import * as placeSearch from '@/lib/mapPlaceSearch'
import { deviceGestureHandling } from '@/lib/mapGestures'


Vue.use(GMap, {
  load: {
    key: GOOGLE_API_KEY,
    libraries: 'places'
  }
})

// XOL-67 (V3): where an option pin's number badge sits. The pin images are 32 to 35 px wide (the Google pin 52) and 52 tall; the badge is centred
// 2 px beyond the image's right edge and 8 px below its top, i.e. beside the upper right corner (UX spec 2.4 "Pin images").
var PIN_WIDTHS = {
  'green-map.png': 32,
  'blue-map.png': 32,
  'yellow-map.png': 32,
  'red-map.png': 32,
  'black-map.png': 35,
  'grey-map.png': 33,
  'google-map.png': 52,
  'outline-map.png': 35
}
var PIN_WIDTH_DEFAULT = 34
var BOUNCE_MS = 700
var PIN_BADGE_Y = 8

export default {
  name: 'google-map',

  mixins: [NumberMixins],

  props: {

    lat: {
      type: [String, Number],
      required: true
    },

    lng: {
      type: [String, Number],
      required: true
    },

    markers: {
      type: Array,
      default: null
    },

    addMarkers: {
      type: Boolean,
      default: false
    },

    deleteMarkers: {
      type: Boolean,
      default: false
    },

    dragMarkers: {
      type: Boolean,
      default: true
    },

    width: {
      type: String,
      default: '100%'
    },

    height: {
      type: String,
      default: '321px'
    },
/*
roadmap
satellite
hybrid
terrain
*/
    mapType: {
      type: String,
      default: 'hybrid'
    },

    mapStyle: {
      type: Array,
      default: null
    },

    zoom: {
      type: Number,
      default: 15
    },

    scrollable: {
      type: Boolean,
      default: false
    },

    draggable: {
      type: Boolean,
      default: false
    },

    clickable: {
      type: Boolean,
      default: true
    },

    showNominal: {
      type: Boolean,
      default: false
    },

    // XOL-67 (V2): the hover text of the pin ("Requested point" on the RTA's request map and on an option's map). null: none, as every other map.
    pinTitle: {
      type: String,
      default: null
    },

    // XOL-67 (V3): the RTA's pins (rtaOption.markersForStepMap / markersForRequestMap / markersForOptionMap): the request's crosshairs, an option's numbered
    // pin, an option's extra markers. null: none, as every other map. The centre pin (`pinned`) is separate: a caller that passes the crosshairs here sets
    // `pinned` to false.
    pinMarkers: {
      type: Array,
      default: null
    },

    // XOL-67 (V4, decision 147; UX spec 2.4.2 item 3): the key of the pin to raise and bounce once (a hovered or focused row of the extra-marker list). null: none.
    highlight: {
      type: String,
      default: null
    },

    // XOL-67 (V4; UX spec 2.4.2 item 1): the key of a pin just added, which Google drops into place. null: none.
    drop: {
      type: String,
      default: null
    },

    // XOL-67 (B11, decision 124): false when there is no nominal point to mark. `lat` / `lng` then only say where the map is
    // centred (a state, the middle of Malaysia, the options), and NO pin is drawn: nothing is shown that was not set.
    pinned: {
      type: Boolean,
      default: true
    },

    // XOL-67 (B11): a click on the map places (or moves) the pin: `update` is emitted with { lat, lng } as for a drag. The parent then
    // holds the point and passes it as `lat` / `lng` with `pinned`.
    placeable: {
      type: Boolean,
      default: false
    },

    showMapType: {
      type: Boolean,
      default: true
    },

    // XOL-67 (v2.2, decisions 171, 175): how the map takes the mouse wheel and touch. Unset (the default) follows the device (`deviceGestureHandling`):
    // 'cooperative' on a desktop, where a plain wheel scrolls the PAGE and Ctrl / Cmd + wheel zooms (Google shows its own "Use ctrl + scroll to zoom the map"
    // hint), and 'greedy' on a phone or tablet, where one finger moves the map and two pinch-zoom it. A value names the handling for every device.
    // `mapOptions` leaves `scrollwheel` unset while a handling is set: an explicit `scrollwheel` of either value overrides it (checked in the browser).
    // '' opts out and gives the old behaviour (the wheel zooms only with `scrollable`). Read once, at creation.
    gestureHandling: {
      type: String,
      default: null
    },

    // XOL-67 (decision 180): fit the map to its pins again whenever a pin is added or removed (the options arriving after the map is drawn). The
    // option map turns this off: adding or deleting an extra marker must not zoom the map out to fit them all (it fits once, when drawn).
    refitOnChange: {
      type: Boolean,
      default: true
    },

    // XOL-67 (v2.2; UX spec C4): the label of the floating pin button, a custom Google control at the bottom centre; null: no button. Pressing it emits
    // `pin-to-centre` { lat, lng, zoom } (the centre of the map NOW, and the zoom it is at). The parent decides what moves; the atom never moves a pin. The icon, the native hover text
    // and the id of the hint the button is described by come from the parent as well.
    centreButton: {
      type: String,
      default: null
    },

    centreIcon: {
      type: String,
      default: 'fa fa-crosshairs'
    },

    // XOL-67 (V8 fixes, decision 179): the accessible name of the grouped control when the `map-controls` slot is used ("Option 2 pin and markers").
    controlLabel: {
      type: String,
      default: null
    },

    centreTitle: {
      type: String,
      default: null
    },

    centreDescribedBy: {
      type: String,
      default: null
    },

    // XOL-67 (v2.2, decision 172; UX spec C6): a "Find a place" search above the map (Google Places, Malaysia only). A pick pans and zooms; it never places a pin.
    searchable: {
      type: Boolean,
      default: false
    },

    // XOL-67 (decision 176): the search row sits BESIDE the `above-map` slot (the slot first, the search to its right on one row) instead of above it. Off: unchanged.
    searchBeside: {
      type: Boolean,
      default: false
    },

    // XOL-67 (v2.2, decision 174; UX spec C8): '16:10' makes the map as tall as a 16:10 rectangle from 992 px up, and between 320 px and half the viewport
    // below it; the `height` prop is then not used. null (every other map): the `height` prop, as before. Only '16:10' is known.
    aspect: {
      type: String,
      default: null,
      validator: function (v) { return v === '16:10' }
    },

    options: {
      type: Array,
      default: null
    },

    optionMapPins: {
      type: Array,
      default: null
    },

    optionIcons: {
      type: Array,
      default: null
    }

  },



  methods: {

    // Do these bounds hold a single point that sits exactly under the centre pin (`mapPosition`)? A new option's pin starts on the requested point, which
    // is the crosshairs. Bounds that cannot say, a map with no pin, and a lone marker anywhere else (SiteCard, a legacy Candidate option) are not.
    isUnderPin (b) {
      if (!this.mapPosition || !b || typeof b.getNorthEast !== 'function' || typeof b.getSouthWest !== 'function') {
        return false
      }

      var ne = b.getNorthEast()
      var sw = b.getSouthWest()

      return !!ne && !!sw && ne.lat() === sw.lat() && ne.lng() === sw.lng() &&
        Math.abs(ne.lat() - this.mapPosition.lat) < 1e-9 && Math.abs(ne.lng() - this.mapPosition.lng) < 1e-9
    },

    resetBounds () {
      if (window.google) {
        this.bounds = new window.google.maps.LatLngBounds()
      } else {
        console.error('window doesn\'t have google prop.', window)
      }

    },


    updatePos (e) {

      if (!e.latLng) {
        console.error('Invalid e.latLng', e)
        return
      }

      let lat = e.latLng.lat()
      let lng = e.latLng.lng()

      if (this.isNumber(lat) && this.isNumber(lng)) {

         this.localLat = lat
         this.localLng = lng

         let p = {lat: this.localLat, lng: this.localLng}

         this.$emit('update', p)
         }
    },

    // XOL-67 (B11): a click on the map (not on a marker) places the pin when the map is `placeable`.
    onMapClick (e) {

      if (!this.placeable || !e || !e.latLng) {
        return
      }

      let lat = e.latLng.lat()
      let lng = e.latLng.lng()

      if (this.isNumber(lat) && this.isNumber(lng)) {

         this.localLat = lat
         this.localLng = lng

         this.$emit('update', {lat: lat, lng: lng})
      }
    },


    /* ---------------------------------------------------------------------
       XOL-67 (v2.2): the floating pin button
    --------------------------------------------------------------------- */

    // The Google map object, once gmap-vue has made it; null before.
    mapObject () {
      var map = this.$refs[this.mapRef]

      return map && map.$mapObject ? map.$mapObject : null
    },

    // Did the caller give the `map-controls` slot (decision 179)? It decides whether the control exists at all; whether it SHOWS depends on its content.
    hasControlSlot () {
      return !!(this.$scopedSlots['map-controls'] || this.$slots['map-controls'])
    },

    // Has the slot something to draw now (an element or text, not the comment a false `v-if` leaves)? This RUNS the slot function: one render calls it up to
    // three times (the wrapper's `v-show`, the divider, the slot itself). Cheap (a few vnodes), and a call inside the render keeps the control reactive to the
    // parent's state, which is why it is not cached.
    controlSlotHasContent () {
      var slot = this.$scopedSlots['map-controls']
      var nodes = slot ? slot() : this.$slots['map-controls']

      return !!(nodes && nodes.some(function (n) { return !!n.tag || !!(n.text && String(n.text).trim()) }))
    },

    // The control is drawn when it has the pin button or slot content.
    controlShown () {
      return !!this.centreButton || this.controlSlotHasContent()
    },

    // Put the control's wrapper into Google's control container (BOTTOM_CENTER, which the map's own controls leave free). Google moves the node, so it is
    // never v-if'ed; beforeDestroy takes it out again. ONLY a map that has a `centreButton` or a `map-controls` slot gets one (a page of SiteCards would
    // otherwise carry a hidden control each). The root `v-if="lat && lng"` can rebuild `gmap-map`: a control left on the old map is dropped and the new map
    // gets its own.
    attachControl () {
      var map = this.$refs[this.mapRef]
      var el = this.$refs.centreControl
      var self = this

      if (!this.centreButton && !this.hasControlSlot()) {
        return
      }

      // Not `window.google` yet: gmap-vue loads the script after this atom is mounted, and `$mapPromise` is what says it has.
      if (!map || !map.$mapPromise || !el) {
        return
      }

      if (this._control && this._control.map === map) {
        return
      }

      this.removeControl()
      this._control = { map: map, list: null, el: null }

      var mine = this._control

      map.$mapPromise.then(function (m) {
        var google = window.google
        var list = m && m.controls && google && google.maps && google.maps.ControlPosition ? m.controls[google.maps.ControlPosition.BOTTOM_CENTER] : null

        // Gone, replaced by another map's control, or no list to put it in.
        if (!list || self._control !== mine || self._isBeingDestroyed || self._isDestroyed || self.$refs[self.mapRef] !== map) {
          return
        }

        list.push(el)
        mine.list = list
        mine.el = el
      })
    },

    // The parts that need the map object or its refs: the pin button, the search's availability and its accessible name. Run at mount, and again when the
    // search turns on after mount or the map is rebuilt.
    setupMapParts () {
      this.attachControl()
      this.checkPlaces()
      this.applySearchLabel()
    },

    // Take the wrapper out of the control container (an MVCArray: getLength / getAt / removeAt), so a remount never leaves two buttons on the map.
    removeControl () {
      var c = this._control

      this._control = null

      if (!c || !c.list || typeof c.list.getLength !== 'function') {
        return
      }

      for (var i = c.list.getLength() - 1; i >= 0; i--) {
        if (c.list.getAt(i) === c.el) {
          c.list.removeAt(i)
        }
      }
    },

    // The button was pressed: the centre of the map NOW, to the parent. Nothing before the map exists.
    onCentreClick () {
      var obj = this.mapObject()
      var centre = obj && typeof obj.getCenter === 'function' ? obj.getCenter() : null

      if (!centre || typeof centre.lat !== 'function') {
        return
      }

      // A pick's "press Add to put the pin there" line is answered by this press.
      this.pickDescription = ''

      // `zoom` is the zoom the user chose: the parent keeps the map there when it hands the new pin back as `lat` / `lng` (it would otherwise reset the zoom).
      this.$emit('pin-to-centre', { lat: centre.lat(), lng: centre.lng(), zoom: typeof obj.getZoom === 'function' ? obj.getZoom() : undefined })
    },

    /* ---------------------------------------------------------------------
       XOL-67 (v2.2): the place search (lib/mapPlaceSearch)
    --------------------------------------------------------------------- */

    // Is Google (with `places`) there? Known at once when the script has loaded; else after gmap-vue's loader answers, or GOOGLE_WAIT_MS (a blocked script).
    checkPlaces () {
      var self = this
      var ask = this.$gmapApiPromiseLazy

      if (!this.searchable) {
        return
      }

      if (placeSearch.placesAvailable(window.google)) {
        this.placesState = 'ready'
        return
      }

      if (typeof ask !== 'function') {
        this.placesState = 'off'
        return
      }

      function settle () {
        if (!self._isBeingDestroyed && !self._isDestroyed) {
          self.placesState = placeSearch.placesAvailable(window.google) ? 'ready' : 'off'
        }
      }

      var timer = setTimeout(settle, GOOGLE_WAIT_MS)

      ask().then(function () {
        clearTimeout(timer)
        settle()
      }, function () {
        clearTimeout(timer)
        settle()
      })
    },

    // Element 2.15's select has no prop for an accessible name on its inner input (the label's `for` ties the id): set it on the input itself.
    applySearchLabel () {
      var select = this.$refs.search
      var reference = select && select.$refs ? select.$refs.reference : null
      var input = reference && reference.$refs ? reference.$refs.input : null

      if (input && typeof input.setAttribute === 'function') {
        input.setAttribute('aria-label', placeSearch.ARIA_LABEL)
      }
    },

    // Element's remote-method: the text in the box (after its 300 ms pause). A keystroke clears the line of the last pick.
    onQuery (text) {
      var query = String(text === undefined || text === null ? '' : text).trim()
      var seq = ++this._searchSeq
      var self = this

      this.pickDescription = ''
      this.pickFailed = false
      this.query = query

      if (query.length < placeSearch.MIN_CHARS) {
        this.searching = false
        this.searchItems = []
        this.searchStatus = query === '' ? '' : 'short'
        return
      }

      if (!this._session) {
        this._session = placeSearch.newSession(window.google)
      }

      this.searching = true

      return placeSearch.searchPlaces(window.google, query, this._session).then(function (r) {
        // A later keystroke (or the end of the atom) made this answer stale.
        if (seq !== self._searchSeq || self._isBeingDestroyed || self._isDestroyed) {
          return
        }

        self.searching = false
        self.searchItems = r.items
        self.searchStatus = r.status
      })
    },

    // A prediction was picked (or the box was cleared): the Geocoder resolves its placeId, the map is fitted to it, NO pin moves, and `place-found` says so.
    onPick (placeId) {
      var self = this
      var seq = ++this._pickSeq

      this.pickFailed = false

      if (!placeId) {
        this.pickDescription = ''
        return
      }

      var item = this.searchItems.filter(function (i) { return i.value === placeId })[0]
      var description = item ? item.label : ''

      // The session's predictions and this pick are one billed session; the next search starts another.
      this._session = null

      return placeSearch.resolvePlace(window.google, placeId).then(function (place) {
        if (seq !== self._pickSeq || self._isBeingDestroyed || self._isDestroyed) {
          return
        }

        if (!place) {
          self.pickDescription = ''
          self.pickFailed = true
          return
        }

        var map = self.$refs[self.mapRef]

        if (map && map.$mapPromise) {
          map.$mapPromise.then(function (m) {
            if (!self._isBeingDestroyed && !self._isDestroyed) {
              placeSearch.fitPlace(window.google, m, place)
            }
          })
        }

        self.pickDescription = description
        self.$emit('place-found', { placeId: placeId, description: description, lat: place.location.lat, lng: place.location.lng })
      })
    },

    // The x of the box: forget the results, the line and the session.
    onSearchClear () {
      this._searchSeq++
      this._pickSeq++
      this._session = null
      this.searchItems = []
      this.searchStatus = ''
      this.searching = false
      this.pickDescription = ''
      this.pickFailed = false
    },

    // XOL-67 (V3): the icon of one of the RTA's pins. An option's pin carries its number as a badge beside the image's upper right corner, so its icon
    // names the label origin (Google's Icon.labelOrigin); every other pin is its image alone.
    pinIcon (m) {
      if (m.kind !== 'pin') {
        return m.icon
      }

      var x = (PIN_WIDTHS[String(m.icon).split('/').pop()] || PIN_WIDTH_DEFAULT) + 2
      var origin = window.google && window.google.maps && typeof window.google.maps.Point === 'function'
        ? new window.google.maps.Point(x, PIN_BADGE_Y)
        : { x: x, y: PIN_BADGE_Y }

      return { url: m.icon, labelOrigin: origin }
    },

    // The number badge of an option's pin (UX spec 2.4 "Pin images": 16 px, #303133, white bold 11 px digit, white ring; the look is the global class below,
    // the label is drawn outside this component). The request's crosshairs and the extra markers carry none.
    pinLabel (m) {
      if (m.kind !== 'pin' || !m.optionNo) {
        return undefined
      }

      return { text: String(m.optionNo), color: '#ffffff', fontSize: '11px', fontWeight: 'bold', className: 'rta-pin-badge' }
    },

    onPinClick (m) {
      this.$emit('pin-click', m)
    },

    // XOL-67 (V4): the pointer is over one of the RTA's pins (`m`) or has left it (null): the extra-marker list tints the matching row.
    onPinHover (m) {
      this.$emit('pin-hover', m)
    },

    // XOL-67 (V4): the pin's animation. The highlighted pin bounces (Google's BOUNCE is 1, stopped after BOUNCE_MS), a pin just added drops (DROP is 2).
    pinAnimation (m) {
      if (m.key === this.bouncing) {
        return 1
      }

      return m.key === this.drop ? 2 : undefined
    },

    // XOL-67 (decision 180): the map's centre NOW, { lat, lng }, or null before Google has drawn it. A new extra marker lands there.
    currentCenter () {
      var map = this.$refs[this.mapRef]
      var obj = map ? map.$mapObject : null
      var c = obj && typeof obj.getCenter === 'function' ? obj.getCenter() : null

      return c ? { lat: c.lat(), lng: c.lng() } : null
    },

    // XOL-67 (decision 180): bring `pos` to the middle and zoom IN to `minZoom` (building level), never out: a map already closer stays as it is.
    focusOn (pos, minZoom) {
      var map = this.$refs[this.mapRef]

      if (!map || !map.$mapPromise || !pos) {
        return
      }

      map.$mapPromise.then(function (m) {
        if (this._isDestroyed) {
          return
        }

        m.panTo(pos)

        if (!(m.getZoom() >= minZoom)) {
          m.setZoom(minZoom)
        }
      }.bind(this))
    },

    // XOL-67 (V4): the map's zoom NOW (the user may have changed it), or the one it was given; where a new extra marker lands depends on it.
    currentZoom () {
      var map = this.$refs[this.mapRef]
      var obj = map ? map.$mapObject : null

      return obj && typeof obj.getZoom === 'function' && obj.getZoom() ? obj.getZoom() : this.zoom
    },

    // A pin was dropped: `pin-move` for any, and `update` for the request's crosshairs (the same event the centre pin sends), so the form that owns the point
    // reads a drag of either one the same way.
    onPinDrag (m, e) {
      if (!e || !e.latLng) {
        console.error('Invalid e.latLng', e)
        return
      }

      var lat = e.latLng.lat()
      var lng = e.latLng.lng()

      if (this.isNumber(lat) && this.isNumber(lng)) {
        this.$emit('pin-move', m, { lat: lat, lng: lng })

        if (m.kind === 'request') {
          this.$emit('update', { lat: lat, lng: lng })
        }
      }
    },

    // Fit the map to every pin when there are two or more (the options are near the request, not on it). One pin keeps the caller's centre and zoom.
    // Street level at the closest, as the one-marker fit. The map object is not there at mount (gmap-vue makes it when Google has loaded), so this waits
    // for `$mapPromise` and fits the Google map itself: the component's own `fitBounds` does nothing until then.
    fitPins () {
      var map = this.$refs[this.mapRef]
      var points = this.pins.map(function (m) { return m.position })

      if (!map || !map.$mapPromise || !window.google || !window.google.maps || points.length < 2) {
        return
      }

      var bounds = new window.google.maps.LatLngBounds()

      points.forEach(function (p) { bounds.extend(p) })

      map.$mapPromise.then((m) => {
        if (this._isDestroyed) {
          return
        }

        m.fitBounds(bounds)

        window.google.maps.event.addListenerOnce(m, 'idle', () => {
          if (m.getZoom() > 17) {
            m.setZoom(17)
          }
        })
      })
    },

    // The distance cell of the marker table: the marker's own, else from the pin; with no pin there is nothing to measure from.
    rowDistance (row) {

      if (row.distance > 0) {
        return this.formatNumber(row.distance, 2) + 'm.'
      }

      if (!this.mapPosition) {
        return 'Not set'
      }

      return this.formatNumber(this.distanceInKmBetween(this.mapPosition.lat, this.mapPosition.lng, row.position.lat, row.position.lng) * 1000, 2) + 'm.'
    },


    updateMarkerPos (e) {

      if (!e.latLng) {
        console.error('Invalid e.latLng', e)
        return
      }

      let lat = e.latLng.lat()
      let lng = e.latLng.lng()

      if (this.isNumber(lat) && this.isNumber(lng)) {

         this.dragLat = lat
         this.dragLng = lng

         if (!this.index) {
            this.$message('Click on the marker to save lat/lng')
         }
      }

    },


    markerDrag (ind) {

      if (!this.dragLat || !this.dragLng) {
        console.error('Invalid drag lat/lng - for marker: ', ind)
        return
      }

      this.index = ind

      this.mrk[this.index].position.lng = this.dragLng
      this.mrk[this.index].position.lat = this.dragLat

      var p = this.mrk[this.index].position

      // With no pin there is no nominal point to measure from: the distance is not set (null), never a number from the map's centre.
      this.mrk[this.index].distance = this.pinned ? this.roundTo(
        this.distanceInKmBetween(this.localLat, this.localLng, p.lat, p.lng) * 1000
        , 2) : null

      this.$emit('changed', this.index, this.mrk[this.index])
      this.index = null

    },


    defaultMapPin () {
      return 'static/map/marker.png'
    },

    // The blue crosshairs (decision 156): the look is rtaOption's, so the request map, an option's map and the Step map draw the same image.
    nominalMapPin () {
      return requestMarkerLook().icon
    },


    position (pos) {
      if (pos.lat && pos.lng) {
        return {lat: Number(pos.lat), lng: Number(pos.lng)}
      } else {
        return null
      }
    },


    typeIcon (type) {
      let i = this.arrayFindIndex(this.options, type)
      return (i >= 0 ? this.optionIcons[i] : null)
    },


    toggleAdd () {

      if (this.adding) {
        this.mrk.push(this.clone(this.marker))
        this.marker = {infoText: null, type: null, position: {lat: this.lat, lng: this.lng}}
      }

      this.adding = !this.adding
      this.item = (this.adding ? 'addMarker' : 'table')
    },


    handleEdit (ind, row) {
        console.log('EDIT ind', ind, row)
    },


    handleDelete (ind, row) {

      this.$confirm('This will permanently marker: ' + row.infoText + '. Continue?', 'Warning', {
               confirmButtonText: 'OK',
               cancelButtonText: 'Cancel',
               type: 'danger'
             })
             .then(() => {

               this.mrk = this.arrayRemoveIndex(this.mrk, ind)

               this.$message({
                 type: 'success',
                 message: 'Delete completed'
               })
             })
             .catch(() => {
               this.$message({
                 type: 'info',
                 message: 'Delete canceled'
               })
             })
    }
  },



  computed: {

    mapPosition: function () {
      if (this.pinned && this.localLat && this.localLng) {
        return {lat: Number(this.localLat), lng: Number(this.localLng)}
      } else {
        return null
      }
    },

    // XOL-67 (v2.2): the map's centre prop. A COMPUTED, so a re-render hands gmap-vue the SAME object until lat / lng change (an inline literal is a new
    // object on every render). gmap-vue 1.5.0 watches the `finalLat` / `finalLng` primitives, so the literal did not move the map in practice: this is the
    // cheap, correct form, not a fix of an observed bug.
    // Is there a start point (the root `v-if`)? The map, its pin button and the search row exist only then.
    hasCentre: function () {
      return !!(this.lat && this.lng)
    },

    mapCenter: function () {
      return {lat: Number(this.localLat), lng: Number(this.localLng)}
    },

    // The map's inline box: a width, and a height unless the aspect ratio sets it (the scoped CSS below).
    mapBox: function () {
      return 'width:' + this.width + (this.aspect === '16:10' ? '' : '; height: ' + this.height)
    },

    // Is the request's point already on the map (the centre pin, or the request's crosshairs among the RTA's pins)? The after-pick line says "Add" or "Center".
    hasPin: function () {
      return !!this.mapPosition || this.pins.some(function (m) { return m.kind === 'request' })
    },

    placesOff: function () {
      return this.placesState === 'off'
    },

    // The row's fixed copy lives in lib/mapPlaceSearch.
    searchLabel: function () {
      return placeSearch.LABEL
    },

    searchLoadingText: function () {
      return placeSearch.LOADING_TEXT
    },

    searchPlaceholder: function () {
      return this.placesOff ? placeSearch.PLACEHOLDER_OFF : placeSearch.PLACEHOLDER
    },

    searchId: function () {
      return 'atom-map-search-' + this._uid
    },

    searchNoData: function () {
      return placeSearch.noDataText(this.searchStatus === 'error' ? 'error' : (this.searchStatus === 'short' ? 'short' : 'empty'), this.query)
    },

    // The line under the search row (aria-live): why the search is off, a pick that did not resolve, or what a pick did and how to put the pin there.
    searchNote: function () {
      if (this.placesOff) {
        return placeSearch.MSG_OFF
      }

      if (this.pickFailed) {
        return placeSearch.MSG_NOT_FOUND
      }

      return this.pickDescription ? placeSearch.afterPickLine(this.pickDescription, this.centreButton, this.hasPin) : ''
    },

    // The RTA's pins that can be drawn: a real position each.
    pins: function () {
      return (this.pinMarkers || []).filter(function (m) {
        return !!m && !!m.position && !!m.key
      })
    },

    // Which pins there are (not where): the map fits them again when this changes (the options arrive after the map is drawn, an add or a delete),
    // never when a pin is only moved.
    pinsSignature: function () {
      return this.pins.map(function (m) { return m.key }).join('|')
    }

  },


  watch: {

    pinsSignature: function () {
      if (this.refitOnChange) {
        this.$nextTick(this.fitPins)
      }
    },

    // The search can turn on after mount (Step 1: `pointEditable` comes from the store): its availability and the select's aria-label are set then.
    searchable: function (on) {
      if (on) {
        this.$nextTick(function () { this.setupMapParts() }.bind(this))
      }
    },

    // The pin button can be given after mount, or taken away: a map with none has no control on it.
    centreButton: function (label) {
      if (label || this.hasControlSlot()) {
        this.$nextTick(function () { this.attachControl() }.bind(this))
      } else {
        this.removeControl()
      }
    },

    // The root v-if rebuilds gmap-map (and the search row): the control and the label follow the new one.
    hasCentre: function (on) {
      if (on) {
        this.$nextTick(function () { this.setupMapParts() }.bind(this))
      } else {
        this.removeControl()
      }
    },

    // A row of the extra-marker list was hovered or focused: its pin bounces once, for BOUNCE_MS.
    highlight: function (key) {
      clearTimeout(this._bounceTimer)

      this.bouncing = key

      if (key) {
        var self = this

        this._bounceTimer = setTimeout(function () { self.bouncing = null }, BOUNCE_MS)
      }
    },

    lat: function (lat) {
      this.localLat = lat
    },

    lng: function (lng) {
      this.localLng = lng
    },

    addMarkers: function (ad) {
      this.canAdd = ad
      this.adding = this.canAdd ? this.adding : false
      this.item = (this.adding ? 'addMarker' : 'table')
    }

  },



  data () {

    return {
      key: GOOGLE_API_KEY,
      mapRef: 'atomMap' + Date.now(),

      localLat: Number(this.lat),
      localLng: Number(this.lng),
      bounds: null,

      mrk: this.markers,

      dragLat: null,
      dragLng: null,

      index: null,
      bouncing: null,
      item: 'table',
      canAdd: this.addMarkers,
      adding: false,

      marker: {infoText: null, type: null, position: {lat: this.lat, lng: this.lng}},

      hasMarkers: this.markers ? true : false,

      // gestureHandling (decisions 171, 175): by device unless the caller names one. `scrollwheel` is NOT set with it: in the browser check ANY explicit
      // `scrollwheel` (true as well as false) overrides the handling, and `true` made a plain wheel zoom the map. '' keeps the old behaviour (the wheel zooms
      // only with `scrollable`).
      mapOptions: Object.assign(
        this.gestureHandling === '' ? { scrollwheel: this.scrollable } : { gestureHandling: this.gestureHandling || deviceGestureHandling() },
        { mapTypeControl: this.showMapType, styles: this.mapStyle }
      ),

      // The place search (searchable): 'wait' (Google not known yet), 'ready' or 'off'; the box, the predictions and the last pick.
      placesState: 'wait',
      picked: '',
      query: '',
      searching: false,
      searchItems: [],
      searchStatus: '',
      pickDescription: '',
      pickFailed: false

    }

  },

  created () {

    // Not reactive: the sequence numbers that make a late search answer stale, the Places session token and the pin button's place in Google's controls.
    this._searchSeq = 0
    this._pickSeq = 0
    this._session = null
    this._control = null

    if (this.markers) {

      this.resetBounds ()

      for (let i = 0; i < this.markers.length; i++) {

        if (this.bounds) {
          this.bounds.extend(this.markers[i].position)
        }

      }  // for

    }
  },

  beforeDestroy () {
    clearTimeout(this._bounceTimer)

    // Take the pin button out of Google's controls, and forget any answer still on its way.
    this.removeControl()
    this._searchSeq++
    this._pickSeq++
  },

  mounted () {

    this.setupMapParts()

    // An empty set of bounds (no marker yet) is not fitted: the map keeps its centre and zoom.
    if (this.bounds && typeof this.bounds.isEmpty === 'function' && !this.bounds.isEmpty()) {
      let map = this.$refs[this.mapRef]

      map.fitBounds(this.bounds)

      // XOL-67 (B11): with no pin, one marker alone would be fitted to the tightest zoom: keep it to a street-level view. (V2: also when the markers
      // are all ONE point under the pin, as a new option's pin starts on the requested point.) A lone marker elsewhere keeps the old fit.
      if ((!this.pinned || this.isUnderPin(this.bounds)) && map.$mapPromise && window.google) {
        map.$mapPromise.then((m) => {
          window.google.maps.event.addListenerOnce(m, 'idle', () => {
            if (m.getZoom() > 17) {
              m.setZoom(17)
            }
          })
        })
      }
    }

    this.fitPins()

  }


}

</script>

<!-- XOL-67 (V3, UX spec 2.4 "Pin images"): the number badge of an option's pin. Google draws a marker label OUTSIDE this component, so the class is global. -->
<style>
.rta-pin-badge {
  width: 16px;
  height: 16px;
  line-height: 16px;
  box-sizing: border-box;
  border-radius: 50%;
  background: #303133;
  border: 1.5px solid #ffffff;
  text-align: center;
  overflow: hidden;
}
</style>

<!-- XOL-67 (v2.2). The pin button's wrapper is moved by Google into its own control container, which keeps the scope attribute on the node. -->
<style scoped>
/* UX spec C4: Library §4a "Map control button". */
.atom-map__control {
  /* the bottom margin clears Google's attribution row (about 14px tall), which is drawn over the bottom controls */
  margin: 10px 10px 26px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
  border-radius: 3px;
}

/* Decision 179: with the `map-controls` slot the control is one grouped panel: the pin button, a thin divider, then the caller's buttons, side by side, centred.
   Google's own controls are white with a 2px radius and a soft shadow; this one wears the same look. */
.atom-map__control--group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 6px;
  max-width: calc(100% - 20px);
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
}

.atom-map__control--group >>> .el-button + .el-button {
  margin-left: 0;
}

/* The caller's buttons are one sub-group: on a narrow map the panel wraps as [pin button] / [the caller's buttons], never through the middle of them. */
.atom-map__control-slot {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.atom-map__control-slot:empty {
  display: none;
}

.atom-map__control-slot >>> .el-button + .el-button {
  margin-left: 0;
}

.atom-map__control-divider {
  align-self: stretch;
  width: 1px;
  margin: 2px 2px;
  background: #DCDFE6;
}

/* On a phone the sub-group sits under the pin button, so the divider would hang at the end of the first row; the buttons are a little tighter. */
@media (max-width: 767px) {
  .atom-map__control-divider {
    display: none;
  }

  .atom-map__control-slot >>> .el-button {
    padding-left: 9px;
    padding-right: 9px;
  }
}

/* Font Awesome icons get no gap from Element (it spaces only el-icon-*): 5px between the icon and the label, as the other buttons of the app. */
.atom-map__control >>> .el-button .fa + span {
  margin-left: 5px;
}

/* UX spec C6: the place search row, above the map. 420px wide, full width when stacked (RtaRequestFields / a narrow screen). */
.atom-map__search {
  display: block;
  margin-bottom: 8px;
}

/* Decision 176: the slot (Lat / Lng) and the search on one row; they wrap onto their own lines when the row is too narrow. The search keeps its label above the
   input, so the slot's content is level with the input (the label's height is the slot's top offset, set by the parent). */
.atom-map__above {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  column-gap: 24px;
}

.atom-map__above > .atom-map__search {
  flex: 1 1 300px;
  max-width: 420px;
  min-width: 0;
}

.atom-map__search-select {
  width: 420px;
  max-width: 100%;
}

.atom-map__search-note {
  display: block;
  min-height: 18px;
  line-height: 1.45;
  margin-top: 2px;
}

/* UX spec C8 (decision 174): below 992px the map is at least 320px and half the viewport tall; from 992px it is 16:10, between 360px and 70% of the viewport.
   gmap-vue's .vue-map is absolutely positioned inside .vue-map-container, so the container needs a height of its own. No feature-query fallback for
   aspect-ratio: every supported browser has it, and cssnano 4 folded the fallback's height into the rule above, so it won in the built CSS. */
.atom-map--aspect {
  height: max(320px, 50vh);
}

@media (min-width: 992px) {
  .atom-map--aspect {
    height: auto;
    aspect-ratio: 16 / 10;
    min-height: 360px;
    max-height: 70vh;
  }
}

</style>

<!-- The search's popper is appended to the body, so it cannot be scoped: two-line rows (UX spec C6: the main text over the secondary one). -->
<style>
.atom-map__search-popper .el-select-dropdown__item {
  height: auto;
  min-height: 34px;
  line-height: 1.4;
  padding-top: 6px;
  padding-bottom: 6px;
}

.atom-map__opt-main {
  display: block;
  color: #303133;
  line-height: 20px;
}

.atom-map__opt-sec {
  display: block;
  color: #8492A6;
  font-size: 12px;
  line-height: 18px;
}
</style>
